import ctl from "@netlify/classnames-template-literals";

export const glassCard = ctl(`
  bg-white/[0.05]
  rounded-2xl
  p-4
  pt-3
  space-y-4
  border
  border-purple-950
`);
